export default __webpack_public_path__ + "static/media/textureBg.bb8a1859.png";